import React from 'react';
import { Facebook, Instagram, Youtube, MapPin, Phone, Clock } from 'lucide-react';
import { Link } from 'react-router-dom';
import proomtbLogo from '../../assets/brand/proomtb-logo.svg';
import raymonLogo from '../../assets/brand/raymon-logo.svg';
import seo from '../../seo/seoConfig.json';

const { business } = seo;

const Footer = () => {
    return (
        <footer className="bg-white text-black py-16 border-t border-gray-100">
            <div className="max-w-[1920px] mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-[minmax(0,1.4fr)_minmax(0,1fr)_minmax(0,1fr)_minmax(0,1.4fr)] gap-12 text-sm">

                    {/* Column 1: Brand */}
                    <div className="space-y-6">
                        <Link to="/" className="flex items-center gap-4">
                            <img src={proomtbLogo} alt="PROO MTB & ROAD (Pro MTB)" width="1065" height="244" loading="lazy" className="h-11 w-auto" />
                            <span className="h-7 w-px bg-gray-300" aria-hidden="true"></span>
                            <img src={raymonLogo} alt="Raymon" width="2820" height="349" loading="lazy" className="h-3 w-auto" />
                        </Link>
                        <p className="text-gray-600">
                            Bicicletas diseñadas para cada camino.<br />
                            Ingeniería alemana. Pasión global.
                        </p>
                        <p className="text-gray-500 text-xs">
                            PROO MTB & ROAD, también conocida como Pro MTB, es distribuidor oficial de Raymon en Santo Domingo.
                        </p>
                        <div className="flex space-x-4">
                            <a href={business.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram de PROOMTB" className="hover:text-gray-900 transition-colors"><Instagram className="w-5 h-5 text-gray-600 hover:text-black" /></a>
                            <a href={business.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook de PROOMTB" className="hover:text-gray-900 transition-colors"><Facebook className="w-5 h-5 text-gray-600 hover:text-black" /></a>
                            <a href={business.youtube} target="_blank" rel="noopener noreferrer" aria-label="YouTube de PROOMTB" className="hover:text-gray-900 transition-colors"><Youtube className="w-5 h-5 text-gray-600 hover:text-black" /></a>
                        </div>
                    </div>

                    {/* Column 2: E-Bikes */}
                    <div>
                        <h3 className="font-bold uppercase tracking-wider mb-4 text-black">E-Bikes</h3>
                        <ul className="space-y-3 text-gray-600">
                            <li><Link to="/category/e-mtb" className="hover:text-black transition-colors">E-MTB</Link></li>
                            <li><Link to="/category/e-trekking" className="hover:text-black transition-colors">E-Trekking</Link></li>
                            <li><Link to="/category/e-city" className="hover:text-black transition-colors">E-City</Link></li>
                            <li><Link to="/ebikes" className="hover:text-black transition-colors">Ver todas</Link></li>
                        </ul>
                    </div>

                    {/* Column 3: Bikes */}
                    <div>
                        <h3 className="font-bold uppercase tracking-wider mb-4 text-black">Bicicletas</h3>
                        <ul className="space-y-3 text-gray-600">
                            <li><Link to="/category/mtb" className="hover:text-black transition-colors">Mountain Bike (MTB)</Link></li>
                            <li><Link to="/category/gravel" className="hover:text-black transition-colors">Gravel</Link></li>
                            <li><Link to="/category/trekking" className="hover:text-black transition-colors">Trekking</Link></li>
                            <li><Link to="/accesorios" className="hover:text-black transition-colors">Accesorios</Link></li>
                            <li><Link to="/tienda" className="hover:text-black transition-colors">Toda la tienda</Link></li>
                        </ul>
                    </div>

                    {/* Column 4: Store location, phone and hours (same data as the Google Business Profile) */}
                    <div>
                        <h3 className="font-bold uppercase tracking-wider mb-4 text-black">Visítanos</h3>
                        <address className="not-italic space-y-4 text-gray-600">
                            <a href={business.mapsUrl} target="_blank" rel="noopener noreferrer" className="flex items-start gap-3 hover:text-black transition-colors">
                                <MapPin className="w-4 h-4 mt-0.5 shrink-0" />
                                <span>{business.streetAddress}<br />{business.addressLocality}, República Dominicana</span>
                            </a>
                            <a href={`tel:${business.telephone.replace(/-/g, '')}`} className="flex items-center gap-3 hover:text-black transition-colors">
                                <Phone className="w-4 h-4 shrink-0" />
                                <span>{business.telephoneDisplay}</span>
                            </a>
                            <div className="flex items-start gap-3">
                                <Clock className="w-4 h-4 mt-0.5 shrink-0" />
                                <ul className="space-y-1">
                                    {business.hours.map(h => (
                                        <li key={h.label}>{h.label}: {h.display}</li>
                                    ))}
                                </ul>
                            </div>
                        </address>
                    </div>

                </div>

                <div className="mt-16 pt-8 border-t border-gray-200 text-xs text-gray-500 flex flex-col md:flex-row justify-between items-center">
                    <p>&copy; {new Date().getFullYear()} Proomtb & Raymon Bicycles. Todos los derechos reservados.</p>
                    <div className="flex space-x-6 mt-4 md:mt-0">
                        <Link to="/privacidad" className="hover:text-black">Privacidad</Link>
                        <Link to="/cookies" className="hover:text-black">Cookies</Link>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
